import { AISuggestion } from '../../../../models/aiClassifications'
import { PAPER_ELEMENT_TYPE } from '../../../../shared/constants/drawable-types'
import store from '../../../../stores'
import { updateSelectedAISuggestion } from '../../../sagas/2D/updateSelectedAISuggestion'
import {
    selectedPaperItem,
    setActiveAiDrawableGroup,
    setSelectedMaterialSubType,
    updateAISuggestionCoordinates,
    updateSelectedAIMaterialType,
} from '../../../slices/2D'
import { IMUP2DCoordinatesToUpdate } from '../../../types'

function selectAiSuggestion(): () => void {
    return function selectDrawable(this: paper.Path) {
        const drawable = this.data.aiSuggestion as AISuggestion

        store.dispatch(setActiveAiDrawableGroup(drawable))

        store.dispatch(updateSelectedAIMaterialType(drawable.type))
        store.dispatch(setSelectedMaterialSubType(drawable.settings.beam_type || null))
        store.dispatch(
            updateSelectedAISuggestion({ aiSuggestionIDs: [this.data.aiSuggestion.id], aiDrawableID: this.id })
        )
    }
}

function deselectAiSuggestion(): () => void {
    return function deselectDrawable(this: paper.Path) {
        store.dispatch(
            selectedPaperItem({
                selectedItem: null,
                activeDrawableId: null,
                activeOpeningLocationId: null,
                openingGroupId: null,
            })
        )
    }
}

function saveAiSuggestion(): (coordinatesToUpdate: IMUP2DCoordinatesToUpdate) => void {
    return function saveSuggestion(this: paper.Item, coordinatesToUpdate) {
        store.dispatch(
            updateAISuggestionCoordinates({
                aiID: this.data.aiSuggestion.id,
                updatedCoordinates: coordinatesToUpdate.coordinates,
            })
        )
    }
}

export default function addSelectFunctionalityToAiSuggestion(drawable: paper.PathItem): void {
    drawable.data.type = PAPER_ELEMENT_TYPE.AI_SUGGESTION
    drawable.data.onSelect = selectAiSuggestion().bind(drawable)
    drawable.data.onDeselect = deselectAiSuggestion().bind(drawable)
    drawable.data.onSave = saveAiSuggestion().bind(drawable)
}
